import {
	CreditCardIcon as CreditCardIconOutline,
	HomeIcon as HomeIconOutline,
	KeyIcon as KeyIconOutline,
} from '@heroicons/react/24/outline';

import {
	HomeIcon as HomeIconSolid,
	CreditCardIcon as CreditCardIconSolid,
	KeyIcon as KeyIconSolid,
} from '@heroicons/react/24/solid';

import { paths } from '../routes';

export const navItems = [
	{
		title: 'Dashboard',
		to: paths.DASHBOARD,
		activeIcon: <HomeIconSolid className='w-4 h-4' />,
		inactiveIcon: <HomeIconOutline className='w-4 h-4' />,
	},
	{
		title: 'Debts',
		to: paths.DEBTS,
		activeIcon: <CreditCardIconSolid className='w-4 h-4' />,
		inactiveIcon: <CreditCardIconOutline className='w-4 h-4' />,
	},
	{
		title: 'API Keys',
		to: paths.API_KEYS,
		activeIcon: <KeyIconSolid className='w-4 h-4' />,
		inactiveIcon: <KeyIconOutline className='w-4 h-4' />,
	},
	// Add more nav items here...
];
